import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { RootState } from "src/redux/reducers";
import { LeftSide } from "./components/LeftSide";
import RightSide from "./components/RightSide";
import { AppConfig } from "src/config/AppConfig";

import "./LoginPage.scss";

export default function LoginPage() {
  const { identity, identifyError } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  useEffect(() => {
    if (Object.keys(identity).length > 0) {
      window.location.href = `${AppConfig.getApiHost()}/workspace`;
    }
  }, [identity]);

  return identifyError ? (
    <div className="login-page">
      <LeftSide />
      <RightSide />
    </div>
  ) : null;
}
